(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acc_mk_homepage_39"] && !window.DesignMode) return;
  try {
    
  var handleLink = document.querySelector('#featured-product-container').getAttribute('data-section');
  console.log('handle: ', handleLink);
  fetch(`https://makani-germany.de/products/${handleLink}?class=Product__media-wrapper`)
  .then(response => response.text())
  .then(html => {
    const container = document.getElementById('acc-sec');
    if(html) {
       container.innerHTML = html;
      container.innerHTML = document.querySelector('#acc-sec .MainProduct').outerHTML
        container.querySelector('.ListMessage').remove();
        container.querySelector('.ProductTabs').remove();
    
        container.querySelectorAll('.Thumbnail__media-item').forEach((el, index) => {
          if(index > 3) {
            el.remove();
          }
        })
    
        const productLinkBtn = `<a type="button" href="/products/${handleLink}" class="Product-form__submit Button Button--full product-link">
                                <span class="Btn_Text">Zum Produkt</span>
                                <span class="ButtonIcon"><svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.45312 15.6984L16.0531 9.0984C16.1531 8.9984 16.2241 8.89006 16.2661 8.7734C16.3075 8.65673 16.3281 8.53173 16.3281 8.3984C16.3281 8.26506 16.3075 8.14006 16.2661 8.0234C16.2241 7.90673 16.1531 7.7984 16.0531 7.6984L9.45312 1.0984C9.26979 0.915064 9.04079 0.819065 8.76612 0.810398C8.49079 0.802398 8.25313 0.898398 8.05313 1.0984C7.85313 1.28173 7.74879 1.51073 7.74012 1.7854C7.73212 2.06073 7.82812 2.2984 8.02812 2.4984L12.9281 7.3984H1.75312C1.46979 7.3984 1.23213 7.49406 1.04012 7.6854C0.848791 7.8774 0.753124 8.11506 0.753124 8.3984C0.753124 8.68173 0.848791 8.91906 1.04012 9.1104C1.23213 9.3024 1.46979 9.3984 1.75312 9.3984H12.9281L8.02812 14.2984C7.84479 14.4817 7.74879 14.7151 7.74012 14.9984C7.73212 15.2817 7.82812 15.5151 8.02812 15.6984C8.21146 15.8984 8.44479 15.9984 8.72812 15.9984C9.01146 15.9984 9.25313 15.8984 9.45312 15.6984Z" fill="#842700"/>
                                </svg>
                                </span></a>`;
        container.querySelector('.product-form__buttons').insertAdjacentHTML('afterbegin', productLinkBtn); 
    }
  })
  .catch(error => {
    console.error('Error fetching HTML content:', error);
  });
window.dispatchEvent(new Event("resize"))

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.querySelectorAll('.Main--Collection .Product__Grid .Grid__Cell').forEach(product =>{
  if(product.querySelector('.acc-atc-btn')){
    product.querySelector('.acc-atc-btn').addEventListener('click', e => {
            console.log('okie')
            let btnText = e.currentTarget.textContent
      		product.querySelector('.ProductItem__Button').click();
      		e.currentTarget.innerHTML = renderIcon().spinner;
      		watchForChanges('#CartDrawer', (mutation, observer) => {
      			if (mutation.target.classList.contains('drawer--is-open')) {
      				product.querySelector('.acc-atc-btn').innerHTML = btnText;
      				observer.disconnect();
      			}
      		});
      	});

}
  
})



function renderIcon() {
	return {
		spinner: `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd" d="M16.8334 23.1318C15.3689 23.7642 13.754 24.1147 12.0573 24.1147C5.39826 24.1147 0 18.7164 0 12.0573C0 5.39826 5.39826 0 12.0573 0C18.1499 0 23.187 4.51875 24 10.3876C23.6986 10.3528 23.392 10.3349 23.0812 10.3349C22.3239 10.3349 21.5914 10.4411 20.8978 10.6395C20.242 6.3145 16.5081 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C13.2144 21 14.3726 20.7595 15.4296 20.3235C15.7084 21.3587 16.1916 22.3102 16.8334 23.1318Z" fill="white"/>
			</svg>

				`,
	};
}

function watchForChanges(
	selector,
	callBack,
	properties = { attributes: true },
) {
	target = document.querySelector(selector);
	const observer = new MutationObserver((mutations, observer) => {
		for (const mutation of mutations) {
			callBack(mutation, observer);
		}
	});

	observer.observe(target, properties);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      var _this1 = this;
      this.section = this.closest('section[data-section-type="recommendation-products"]');

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML; 
              
              // Fire Event to build slider
              document.dispatchEvent(new CustomEvent('recommendations:loaded', {
                detail: {
                  section: _this1.section
                }
              }));
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
